module.exports = __webpack_public_path__ + "img/box_gable.c968d00d.jpg";